import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyCX2RJU14jKVppOfxFR2rXjeM1jQdZVNVg",
  authDomain: "weekly-budgeting-2807d.firebaseapp.com",
  projectId: "weekly-budgeting-2807d",
  storageBucket: "weekly-budgeting-2807d.firebasestorage.app",
  messagingSenderId: "841857931450",
  appId: "1:841857931450:web:06b5df2cb59b5c93f8ca83"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app; 